// lib/utils/coveo/helpers/useEngine.ts

import { buildSearchEngine, SearchEngine, SearchEngineConfiguration } from '@coveo/headless';
import { useMemo } from 'react';

let engine: SearchEngine | null = null;

interface UseEngineOptions {
  accessToken: string;
  organizationId: string;
  searchHub?: string;
  pipeline?: string;
}

/**
 * Returns a singleton instance of the Coveo Headless search engine.
 * Allows dynamic configuration of accessToken, organizationId, searchHub, and pipeline.
 */
export const useSearchEngine = (options: UseEngineOptions): SearchEngine => {
  const {
    accessToken,
    organizationId = process.env.NEXT_PUBLIC_COVEO_ORG_ID!,
    searchHub = 'default',
    pipeline,
  } = options;

  const config: SearchEngineConfiguration = {
    accessToken,
    organizationId,
    search: {
      searchHub,
      pipeline,
    },
  };

  return useMemo(() => {
    if (!engine) {
      engine = buildSearchEngine({ configuration: config });
    }
    return engine;
  }, [accessToken, organizationId, searchHub, pipeline]);
};
